import { render, staticRenderFns } from "./promo_page_link.vue?vue&type=template&id=c3e5f272"
import script from "./promo_page_link.vue?vue&type=script&lang=js"
export * from "./promo_page_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports